import React from 'react'
import TechProfileComponent from '../components/TechProfile'

function TechProfile() {
  return (
    <div>
      <TechProfileComponent />
    </div>
  )
}

export default TechProfile